// @types
import { TranHoverType, TranEnterType, TranExitType } from '../types';

// As a rule of thumb, UI animations should generally stay under 300ms. https://emilkowal.ski/ui/you-dont-need-animations
const DEFAULT_HOVER_DURATION = 0.2;
const DEFAULT_ENTER_DURATION = 0.2;
const DEFAULT_EXIT_DURATION = 0.2;
const DEFAULT_EASE = 'ease-out';

// ----------------------------------------------------------------------

export const varTranHover = (props?: TranHoverType) => {
  const duration = props?.duration || DEFAULT_HOVER_DURATION;
  const ease = props?.ease || DEFAULT_EASE;

  return { duration, ease };
};

export const varTranEnter = (props?: TranEnterType) => {
  const duration = props?.durationIn || DEFAULT_ENTER_DURATION;
  const ease = props?.easeIn || DEFAULT_EASE;

  return { duration, ease };
};

export const varTranExit = (props?: TranExitType) => {
  const duration = props?.durationOut || DEFAULT_EXIT_DURATION;
  const ease = props?.easeOut || DEFAULT_EASE;

  return { duration, ease };
};
